<template>
  <b-alert
    class="alert-message form-alert"
    fade
    :show="countdown"
    :dismissible="dismissable"
    :variant="variant"
    @dismiss-count-down="countdownChanged"
    @dismissed="onDismiss"
  >
    <template slot="dismiss">Hide</template>

    <p
      @click="onClick"
      :class="[
        'form-alert__text',
        {
          'form-alert__text--fn': click
        }
      ]"
    >
      {{ label }}
    </p>
  </b-alert>
</template>
<script>
/**
 * ==================================================================================
 * Alert message positioned at the bottom part of the screen
 * ==================================================================================
 **/

import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      alert: state => state.alert.alertDetails
    }),
    variant() {
      return this.state ? 'primary' : 'danger'
    }
  },
  watch: {
    alert(newValue) {
      if (newValue && newValue.label) {
        this.setAlert(newValue)
        this.removeAlert()
      }
    }
  },
  data: function() {
    return {
      dismissable: true,
      emitDismiss: false,
      dismissed: null,
      state: true,
      label: null,
      countdown: 0,
      click: null
    }
  },
  methods: {
    ...mapActions({
      removeAlert: 'alert/removeAlert'
    }),

    onClick() {
      if (this.click) {
        this.click()
      }
    },

    onDismiss() {
      if (typeof this.dismissed === 'function') {
        this.dismissed()
      }
      if (this.emitDismiss) {
        this.$root.$emit('alert-message-dismissed', this.label)
      }
    },

    setAlert(alert) {
      this.dismissable = alert.dismissable || true
      this.emitDismiss = alert.emitDismiss || false
      this.state = alert.state === undefined ? true : alert.state
      this.countdown = alert.countdown || 3
      this.label = alert.label
      this.dismissed = alert.dismissed || null
      this.click = alert.click || null
    },

    countdownChanged(countdown) {
      this.countdown = countdown
    }
  },
  created() {
    this.$root.$on('alert-message-remove', (label = null) => {
      if (!label || label === this.label) {
        this.countdown = false
      }
    })

    this.$root.$on('alert-message-dismiss', () => {
      this.countdown = 0
    })
  }
}
</script>
<style lang="scss" scoped>
.alert-message {
  p {
    width: 80%;
    margin: 0 auto;
  }
}

@media (max-width: 568px) {
  .alert-message /deep/ {
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      text-align: left;
      margin-left: 0.5rem;
    }

    button.close {
      position: relative;
      top: inherit;
      right: inherit;
      display: flex;
      padding: 0;
      order: 1;
    }
  }
}
</style>
